import { BoxProps } from 'UIKit/Box/types'
import React, { useMemo } from 'react'
import styled from 'styled-components'

import { Trans } from 'react-i18next'

import Box from 'UIKit/Box/Box'
import Flex from 'UIKit/Box/Flex'
import Text from 'UIKit/Text'
import TokenLogo from 'UIKit/TokenLogo'
import { BIG_ZERO } from 'config/constants/number'
import { USD_CURRENCY } from 'config/constants/tokens'
import { TokenAmount } from 'config/types'
import { RowCenter } from 'layout/Components/Row'
import { Icons } from 'svgs'
import colors from 'theme/ui/colors'
import { delineate } from 'utils/formatBalance'
import { InHouseLabel } from 'views/InhouseGame/components/styled'
import { generateMineGameMultiplier } from '../../config/utils'
import useMineEstProfitModal from './MineEstimateProfitModalDetails'

const MineEstimateProfit: React.FC<
  BoxProps & {
    mines: number
    betAmount: TokenAmount
    current?: number
  }
> = ({ betAmount, mines, current, ...props }) => {
  const [present] = useMineEstProfitModal()

  const profits = useMemo(() => {
    return generateMineGameMultiplier(mines)
  }, [mines])

  const amount = useMemo(() => {
    return betAmount ? betAmount.amount : BIG_ZERO
  }, [betAmount])
  return (
    <Box width="100%" mb="16px" {...props}>
      <StyledLabel
        alignItems="center"
        justifyContent="flex-start"
        mb="6px"
        onClick={() => {
          present({ betAmount, mines, current })
        }}
      >
        <InHouseLabel mb="0px !important" mr="6px">
          <Trans>Max Profit ({{ multiplier: `${delineate(profits[profits.length - 1].toString(), 3)}x` }})</Trans>
        </InHouseLabel>
        <Icons.InfoIcon width="16px" fill={colors.textSubtle} />
      </StyledLabel>

      <StyledValueBox>
        <Text small mr="12px">
          $
          {!amount.gt(0)
            ? 0
            : delineate(
                amount
                  .multipliedBy(profits[profits.length - 1])
                  .minus(amount)
                  .toString(10),
                2,
              )}
        </Text>
        <TokenLogo
          token={betAmount?.token || USD_CURRENCY}
          size={16}
          minWidth={16}
          networkImageProps={{
            width: 10,
            height: 10,
          }}
        />
      </StyledValueBox>
    </Box>
  )
}

const StyledValueBox = styled(RowCenter)`
  padding-right: 12px;
  background: ${({ theme }) => theme.colors.backgroundAlt5};
  border-radius: ${({ theme }) => theme.radii.tiny};
  height: 40px;
  justify-content: flex-end;
  padding-left: 12px;
`

const StyledLabel = styled(Flex)`
  cursor: pointer;

  &:hover {
    * {
      color: ${({ theme }) => theme.colors.textTertiary} !important;
      fill: ${({ theme }) => theme.colors.textTertiary} !important;
    }
  }
`

export default MineEstimateProfit
